import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=376301a6&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=376301a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376301a6",
  null
  
)

export default component.exports